import { Text } from "../../Text/Text/Text";
import styles from "./PullQuoteSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PullQuoteSlice = function PullQuoteSlice(_ref) {
  var quote = _ref.quote,
    attribution = _ref.attribution;
  return /*#__PURE__*/_jsx("div", {
    className: styles.wrapper,
    children: /*#__PURE__*/_jsx("blockquote", {
      className: styles.quote,
      children: /*#__PURE__*/_jsxs(Text, {
        typog: "subhead1",
        children: [/*#__PURE__*/_jsx("span", {
          children: "\"".concat(quote, "\"")
        }), attribution && /*#__PURE__*/_jsx("span", {
          children: "\u2014 ".concat(attribution)
        })]
      })
    })
  });
};